import { useState } from 'react';
import { useAppContext } from '../../application/App.Context';
import { Typography, Dialog, DialogContent, DialogContentText, DialogActions, Button, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { equivalencyRequestNavigation } from '../../application/App.routes';

const AuthSuggestionModal = () => {
  const { t } = useTranslation();
  const {login } = useAppContext();
  const [openAuthSuggestionModal, setOpenAuthSuggestionModal] = useState<boolean>(false);

  // Disabling AuthSuggestionModal
  // useEffect(() => {
  //   const shouldDisplayAuthSuggestionModal = window.sessionStorage.getItem('shouldDisplayAuthSuggestionModal') ?? 'true';
  //   if (haveWeTriedToAuthenticate && !user.valid && shouldDisplayAuthSuggestionModal === 'true') {
  //     window.sessionStorage.setItem('shouldDisplayAuthSuggestionModal', 'false');
  //     setOpenAuthSuggestionModal(true);
  //   }
  // }, [haveWeTriedToAuthenticate]);

  const handlerCloseAuthSuggestionModal = () => {
    setOpenAuthSuggestionModal(false);
  }

  const handlerLogin = () => {
    login();
  }

  return (<>
    {openAuthSuggestionModal &&
      <Dialog
        open={openAuthSuggestionModal}
        onClose={handlerCloseAuthSuggestionModal}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        fullWidth
        maxWidth='sm'
      >
        <DialogContent>
          <DialogContentText id='alert-dialog-description' style={{ display: 'flex', flexDirection: 'column', gap: 6, color: 'black' }}>
            <Typography fontSize='20px' marginBottom={'14px'} fontWeight='bold'>{t('authSuggestionTitle')}</Typography>
            <Typography marginBottom={'10px'} >{t('authSuggestion')}</Typography>
            <Typography>
              {t('exploreEquivalencySuggestion')}
              <Box component={NavLink} to={equivalencyRequestNavigation.consultEquivalency()} onClick={handlerCloseAuthSuggestionModal}>
                <u style={{ cursor: 'pointer', color: '#479184' }}>
                  {t('hereLabel')}
                </u>
              </Box>
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handlerLogin} color='primary'>
            {t('loginLabel')}
          </Button>
          <Button onClick={handlerCloseAuthSuggestionModal} color='primary'>
            {t('skipLabel')}
          </Button>
        </DialogActions>
      </Dialog>
    }
  </>
  );
};

export default AuthSuggestionModal;
